import { mapState } from 'vuex'

export default {
  data() {
    return {
      searchText: '',
      activeSearch: false,
    }
  },
  computed: {
    ...mapState('mobile', ['isMobile', 'isTablet', 'isTabletHeader']),
  },
  watch: {
    $route: function() {
      if (this.$route.name === 'search' && this.$route.query.q && this.searchText !== '') {
        this.searchText = this.$route.query.q
      }
    },
  },
  methods: {
    submitSearch() {
      if (this.searchText.length > 2 && this.$route.query.q !== this.searchText) {
        this.$router.push({ name: 'search', query: { q: this.searchText } })
      }
      // else {
      //     this.$router.push({ name: 'search', query: {q: undefined} });
      // }
    },
  },
}



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/search/component.js